
import * as Inovx from '@shared';
import assign from 'object-assign';
import { apiPostFormUrlEncoded, FormUrlEncodedBody } from '@shared/api/apiClient';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/AssemblyLibrary`;

var AssemblyLibraryServices: IAssemblyLibraryServices = assign({}, Inovx.Shared.Flux.BaseService, {
    getAssemblyLibraries: function () {
        return new Promise<IAssemblyLibrary[]>((resolve, reject) => {
            this.get(`${url}`,
                { },
                (retData: IAssemblyLibrary[]) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getAssemblyLibrariesWithTemplates: function () {
        return new Promise<IAssemblyLibraryWithTemplates[]>((resolve, reject) => {
            this.get(`${url}/WithTemplates`,
                {},
                (retData: IAssemblyLibraryWithTemplates[]) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    createAssemblyLibrary: function (data: IAssemblyLibrary) {
        return new Promise<IAssemblyLibrary>((resolve, reject) => {
            apiPostFormUrlEncoded<IAssemblyLibrary>(url + "/Create", data as FormUrlEncodedBody, { responseType: 'text' })
                .then((result: IAssemblyLibrary) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                });

        });
    },
    deleteAssemblyLibrary: function (data: IAssemblyLibrary) {
        return new Promise<void>((resolve, reject) => {
            this.post(`${url}/Delete`,
                { ID: data.ID, VersionToken: data.VersionToken },
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getAssemblyTemplates: function (libraryID: string) {
        return new Promise<IAssemblyTemplate[]>((resolve, reject) => {
            this.get(`${url}/Templates/ByLibrary`,
                { libraryID: libraryID },
                (retData: IAssemblyTemplate[]) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    createAssemblyTemplate: function (data: IAssemblyTemplate) {
        return new Promise<IAssemblyTemplate>((resolve, reject) => {
            apiPostFormUrlEncoded<IAssemblyTemplate>(url + "/Templates/Create", data as FormUrlEncodedBody, { responseType: 'text' })
                .then((result: IAssemblyTemplate) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                });

        });
    },
    updateAssemblyTemplate: function (data: IAssemblyTemplate) {
        return new Promise<IAssemblyTemplate>((resolve, reject) => {
            apiPostFormUrlEncoded<IAssemblyTemplate>(url + "/Templates/Update", data as FormUrlEncodedBody, { responseType: 'text' })
                .then((result: IAssemblyTemplate) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                });

        });
    },
    deleteAssemblyTemplate: function (data: IAssemblyTemplate) {
        return new Promise<void>((resolve, reject) => {
            this.post(`${url}/Templates/Delete`,
                { ID: data.ID, VersionToken: data.VersionToken },
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    }
});

export default AssemblyLibraryServices;